module.exports = __webpack_public_path__ + "img/banner_wx_m.ad345c26.png";